// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select {
  max-width: 100% !important;
  width: 100%;
}

.labels {
  opacity: 100% !important;
}

.item-text {
  --min-height: 20px;
}

.full-width {
  width: 100%;
  max-width: 100%;
}

.grid-dob {
  margin: 0px;
}
.grid-dob ion-col {
  border: solid 1px #fff;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/reset-password/reset-password-verify-second-step/reset-password-verify-second-step.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,WAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;AACJ;AACI;EACI,sBAAA;EACA,kBAAA;AACR","sourcesContent":["ion-select{\r\n    max-width: 100% !important;\r\n    width: 100%;\r\n}\r\n\r\n.labels {\r\n    opacity: 100%!important;\r\n}\r\n\r\n.item-text {\r\n    --min-height: 20px;\r\n}\r\n\r\n.full-width {\r\n    width: 100%;\r\n    max-width: 100%;\r\n}\r\n\r\n.grid-dob {\r\n    margin: 0px;\r\n\r\n    ion-col {\r\n        border: solid 1px #fff;\r\n        text-align: center;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
